import React, { useEffect, useRef, useState } from 'react'
import Loading from '@/components/base/loading'
import { accessTokenFromCookie, createDetailBridge, queryTalk } from './detail-bridge.mjs'

type Props = {
    origin: string
    path: string
    page: 'call-detail' | 'talk-detail'
    title: string
    styles: { container: string; loading: string; iframe: string }
}

// Next build: the business page reports its state and proxies Talk Detail reads through the parent.
export default function BusinessDetailFrame({ origin, path, page, title, styles }: Props) {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [attempt, setAttempt] = useState(0)
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const params = new URLSearchParams({ nextCompat: 'detail-v1', hideHeader: 'true' })
    params.set('nextDetailBridge', 'v1')
    const src = `${origin}${path}?${params.toString()}`

    useEffect(() => createDetailBridge({
        origin: new URL(origin).origin,
        page,
        getWindow: () => iframeRef.current?.contentWindow,
        receive: window,
        onState: (state: string) => {
            setLoading(state === 'loading')
            setError(state === 'error' ? 'Unable to load detail settings. Please retry.' : null)
        },
        query: (request: any) => queryTalk(request, { token: accessTokenFromCookie(document.cookie) })
    }), [attempt])

    return (
        <div className={styles.container}>
            {loading && (
                <div className={styles.loading}>
                    <Loading />
                </div>
            )}
            {error && (
                <div role="alert" className={styles.loading}>
                    <p>{error}</p>
                    <button onClick={() => { setError(null); setLoading(true); setAttempt(n => n + 1) }}>Retry</button>
                </div>
            )}
            <iframe
                key={attempt}
                ref={iframeRef}
                style={loading || error ? { visibility: 'hidden' } : undefined}
                src={src}
                className={styles.iframe}
                title={title}
                referrerPolicy="origin"
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-downloads"
            />
        </div>
    )
}
